import { render, staticRenderFns } from "./DialogSupport.vue?vue&type=template&id=049910f0"
import script from "./DialogSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSupport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports